import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
   providedIn: 'root',
})

export class UserService {
   private baseURL;
   bearerToken;
   private loggedInUsersName: string;
   private loggedInUserId: number;
   private loggedInUserNameSubject = new BehaviorSubject<string>('');
   loggedInUserName$ = this.loggedInUserNameSubject.asObservable();

   constructor(private http: HttpClient,
      private authService: AuthService) {
      this.baseURL = environment.apiBaseUrl;
   }

   generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
         var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
         return v.toString(16);
      });
   }

   setSessionData(vendorId: string) {
      if (!sessionStorage.getItem('tabId')) {
         sessionStorage.setItem('tabId', this.generateUUID());
      }
      const tabId = sessionStorage.getItem('tabId');
      const key1 = `vendorId-${tabId}`;
      localStorage.setItem(key1, vendorId);
   }

   setLoggedInUserName(userName: string) {
      this.loggedInUsersName = userName;
      localStorage.setItem('ASCUserName', userName);
      this.loggedInUserNameSubject.next(userName);
   }

   getLoggedInUserName() {
      return this.loggedInUsersName;
   }

   setLoggedInUserId(userId: number) {
      this.loggedInUserId = userId;
   }

   getLoggedInUserId() {
      return this.loggedInUserId;
   }
   getVendorId(): string | null {
      const tabId = sessionStorage.getItem('tabId');
      const key1 = `vendorId-${tabId}`;
      return localStorage.getItem(key1);
   }

   getToken(userData): Observable<any> {
      const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
      const url = `${this.baseURL}/user`;
      return this.http.post<any>(url, userData, options)
         .pipe(
            map(res => {
               if (res.Token) {
                  this.authService.isLoggedIn = true;
                  if (!sessionStorage.getItem('tabId')) {
                     sessionStorage.setItem('tabId', this.generateUUID());
                  }
                  const tabId = sessionStorage.getItem('tabId');
                  const key = `authToken-${tabId}`;
                  const sessionIdKey = `UniqueSessionId-${tabId}`;
                  localStorage.setItem(key, res.Token);
                  localStorage.setItem(sessionIdKey, res.TokenUniqueGUID);
                  return res;
               }
               else {
                  this.authService.isLoggedIn = false;
               }
            }),
            catchError(this.handleError)
         );
   }

   updateSwitchedMarketId(marketId): Observable<any> {
      const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
      const url = `${this.baseURL}/user/UpdateDefaultMarketId?switchedMarketId=${marketId}`;
      return this.http.post<any>(url, options)
         .pipe(
            map(res => {
               const response = res as any[];
               return response;
            }),
            catchError(this.handleError)
         );
   }

   clearToken(): Observable<any> {
      const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
      const url = `${this.baseURL}/User/AddLogout`;
      return this.http.post<any>(url, options)
         .pipe(
            map(res => {
               const response = res as any;
               const tabId = sessionStorage.getItem('tabId');
               const key = `authToken-${tabId}`;
               localStorage.removeItem(key);
               localStorage.removeItem('ASCUserName');
               this.authService.isLoggedIn = false;
               return response;
            }),
            catchError(this.handleError)
         );
   }

   getUserList(): Observable<any> {
      return this.http.get<any>(
         `${this.baseURL}/User/GetUserList`,
         { observe: 'response' }
      ).pipe(
         map((res: HttpResponse<any>) => res.body),
         catchError(this.handleError)
      );
   }

   SaveUser(user): Observable<any> {

      const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
      const url = `${this.baseURL}/User/SaveUser`;
      return this.http.post<any>(url, user, options)
         .pipe(
            map(res => {
               const response = res as any[];
               return response;
            }),
            catchError(this.handleError)
         );
   }


   private handleError(error: HttpErrorResponse) {
      if (error.error instanceof Error) {
         const errMessage = error.error.message;
         return throwError(errMessage);
      }
      return throwError(error || 'Node.js server error');
   }

   updateUserPasswordExpDate(passwordResetDays): Observable<any> {
      return this.http.get<any>(
         `${this.baseURL}/user/UpdateUserPasswordExpDate?PasswordResetDays=${passwordResetDays}`,
         { observe: 'response' })
         .pipe(
            map(res => {
               return res.body as any;
            }),
            catchError(this.handleError)
         );
   }

   getUserPasswordExpDate(): Observable<any> {
      return this.http.get(
         `${this.baseURL}/user/GetUserPasswordExpiryDays`,
         { observe: 'response' })
         .pipe(
            map(res => {
               return res.body;
            }),
            catchError(this.handleError)
         );
   }

   ResetPassword(userData): Observable<any> {
      const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
      const url = `${this.baseURL}/User/ResetPassword`;
      return this.http.post<any>(url, userData, options)
         .pipe(
            map(res => {
               const response = res as any[];
               return response;
            }),
            catchError(this.handleError)
         );
   }

   GetUserAssignedMarkets(Id: number): Observable<any> {

      return this.http.get<any>(
         `${this.baseURL}/MarketInfo/GetAllActiveMarketforUser?Id=${Id}`,
         { observe: 'response' })
         .pipe(
            map(res => {
               const result = res.body as any;
               return result;
            }),
            catchError(this.handleError)
         );
   }

   UpdateOrSaveAssignUserToMarket(AssignUser): Observable<any> {

      const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
      const url = `${this.baseURL}/User/UpdateOrSaveAssignedUser`;
      return this.http.post<any>(url, AssignUser, options)
         .pipe(
            map(res => {
               const response = res as any[];
               return response;
            }),
            catchError(this.handleError)
         );
   }

   GetUserById(Id: number): Observable<any> {
      return this.http.get<any>(
         `${this.baseURL}/User/GetUserById?Id=${Id}`,

         { observe: 'response' })
         .pipe(
            map(res => {
               const result = res as any;
               return result;
            }),
            catchError(this.handleError)
         );
   }

   getDefaultTerminalId(): Observable<any> {
      return this.http.get<any>(
         `${this.baseURL}/User/GetDefaultTerminalId`,
         { observe: 'response' })
         .pipe(
            map(res => {
               return res.body as any;
            }),
            catchError(this.handleError)
         );
   }

   UpdatePasscode(user): Observable<any> {

      const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
      const url = `${this.baseURL}/User/UpdatePasscode`;
      return this.http.post<any>(url, user, options)
         .pipe(
            map(res => {
               const response = res as any[];
               return response;
            }),
            catchError(this.handleError)
         );
   }

   GetAcessFunctionsByUserID(userid: number): Observable<any> {
      const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
      const url = `${this.baseURL}/User/GetUserAccessData?userid=${userid}`;
      return this.http.post<any>(url, {}, options)
         .pipe(
            map(res => {
               const result = res as any;
               return result;
            }),
            catchError(this.handleError)
         );
   }

   GetAllRentalTypes(Id: number): Observable<any> {
      const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
      const url = `${this.baseURL}/User/GetUserRentalTypeData?userid=${Id}`;
      return this.http.post<any>(url, {}, options)
         .pipe(
            map(res => {
               const result = res as any;
               return result;
            }),
            catchError(this.handleError)
         );
   }

   GetAllPosSalesTypes(Id: number): Observable<any> {
      const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
      const url = `${this.baseURL}/User/GetUserSalesTypeData?userid=${Id}`;
      return this.http.post<any>(url, {}, options)
         .pipe(
            map(res => {
               const result = res as any;
               return result;
            }),
            catchError(this.handleError)
         );
   }

   UpdateUserRights(data): Observable<any> {
      const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
      const url = `${this.baseURL}/User/UpdateUserRights`;
      return this.http.post<any>(url, data, options)
         .pipe(
            map(res => {
               const response = res as any[];
               return response;
            }),
            catchError(this.handleError)
         );
   }

   GetUserRoles(userId): Observable<any> {
      return this.http.get<any>(
         `${this.baseURL}/User/GetUserRoles?userId=${userId}`,

         { observe: 'response' })
         .pipe(
            map(res => {
               const result = res.body as any;
               return result;
            }),
            catchError(this.handleError)
         );
   }

   CheckUserTransaction(Id: number): Observable<any> {
      return this.http.get<any>(
         `${this.baseURL}/User/CheckUserTransaction?Id=${Id}`,

         { observe: 'response' })
         .pipe(
            map(res => {
               const result = res.body as any;
               return result;
            }),
            catchError(this.handleError)
         );
   }

   DeleteUserById(Id: number): Observable<any> {
      return this.http.get<any>(
         `${this.baseURL}/User/DeleteUser?Id=${Id}`,

         { observe: 'response' })
         .pipe(
            map(res => {
               const result = res as any;
               return result;
            }),
            catchError(this.handleError)
         );
   }

   CheckUserNameExistOrNot(validate): Observable<any> {
      return this.http.post<any>(
         `${this.baseURL}/User/CheckUserNameExistOrNot`,
         validate,
         { observe: 'response' })
         .pipe(
            map(res => {
               const result = res as any;
               return result;
            }),
            catchError(this.handleError)
         );
   }

   ForgotPassword(email): Observable<any> {
      const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
      const url = `${this.baseURL}/user/ForgotPassword`
      return this.http.post<any>(url, { email }, options)
         .pipe(
            map(res => {
               const response = res as any[];
               return response;
            }),
            catchError(this.handleError)
         );
   }

   GetCurrentUserById(): Observable<any> {
      return this.http.get<any>(
         `${this.baseURL}/User/GetCurrentUserById`,

         { observe: 'response' })
         .pipe(
            map(res => {
               const result = res.body as any;
               return result;
            }),
            catchError(this.handleError)
         );
   }

   UpdateSalesTypeForAllUsers(data): Observable<any> {
      const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

      const url = `${this.baseURL}/User/UpdateSalesTypeForAllUsers`;

      return this.http.post<any>(url, data, options)
         .pipe(
            map(res => {
               const result = res as any;
               return result;
            }),
            catchError(this.handleError)
         );
   }

}
